import React from 'react';
import { MdTune } from 'react-icons/md';
import { FiTrash2 } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import CommonMenu from './CommonMenu';

const GroupOptionsMenu = ({ isOpen, onSelect, onClose }) => {
    const { t } = useTranslation();

    if (!isOpen) return null;

    const items = [
        {
            id: 'editGroup',
            label: t("categories.menu.editGroup", "Редактировать группу"),
            icon: <MdTune size={20} />,
            onClick: () => {
                onSelect("editGroup");
                onClose();
            }
        },
        {
            id: 'deleteGroup',
            label: t("categories.menu.deleteGroup", "Удалить группу"),
            icon: <FiTrash2 size={20} />,
            className: "text-red-500",
            onClick: () => {
                onSelect("deleteGroup");
                onClose();
            }
        }
    ];

    return <CommonMenu onClose={onClose} items={items} />;
};

export default GroupOptionsMenu; 